// import classnames from "classnames";
import { observer } from "mobx-react-lite";
import {
  BoxProps,
  Center,
  FlexProps,
  forwardRef,
  PlacementWithLogical,
  SystemStyleObject,
  Text,
  TextProps,
  Tooltip,
} from "@chakra-ui/react";

// import "../Icon/index.scss";
import { themeStore } from "@/stores/theme";
// import { genBlock } from "@/utils/bem";
import Icon from "../Icon";
import { ReactNode, useMemo, useState } from "react";

export interface IIconButton extends BoxProps {
  fillbyCurrentColor?: boolean;
  strokeByCurrentColor?: boolean;
  fillAll?: boolean;
  disabled?: boolean;
  icon: React.FC<{ className?: string }>;
  text?: string;
  style?: React.CSSProperties;
  tip?: ReactNode;
  placement?: PlacementWithLogical;
  textProps?: TextProps;
  wrapProps?: FlexProps;
}
const IconButton = forwardRef<IIconButton, "div">(
  (
    {
      text = "",
      style,
      textProps = {},
      strokeByCurrentColor,
      fillAll,
      fillbyCurrentColor,
      icon,
      className,
      disabled,
      tip,
      placement = "bottom",
      wrapProps,
      ...others
    },
    ref,
  ) => {
    return (
      <Center
        ref={ref}
        w="32px"
        h="32px"
        flexDir="column"
        fontSize="12px"
        transition="color,background 0.3s cubic-bezier(.08,.52,.52,1)"
        cursor={disabled ? "auto" : "pointer"}
        {...others}
      >
        <Tooltip
          label={tip}
          placement={placement}
          isDisabled={!tip}
          bg="fill.icon"
          p="8px 12px"
          color="#ffffff"
          rounded="2px"
          hasArrow
          arrowSize={9}
        >
          <Center flexDir="column" {...wrapProps}>
            <Icon
              svg={icon}
              className={className}
              squared={false}
              style={{ flexShrink: 0, ...(style ?? {}) }}
              fillbyCurrentColor={fillbyCurrentColor}
              strokeByCurrentColor={strokeByCurrentColor}
              fillAll={fillAll}
              disabled={disabled}
            />
            {text ? (
              <Text {...textProps} fontSize="14px">
                {text}
              </Text>
            ) : null}
          </Center>
        </Tooltip>
      </Center>
    );
  },
);

export default observer(IconButton);
